import './web_chat.less';

import * as Share             from '../util/share';
import { ArrowRight }         from 'react-feather';
import { File as FileIcon }   from 'react-feather';
import { Send as SendIcon }   from 'react-feather';
import { Share as ShareIcon } from 'react-feather';
import Link                   from '../components/link';
import OnboardingSection      from './onboarding_section';
import qs                     from 'query-string';
import React                  from 'react';
import useCompleted           from './use_completed';


export default function WebChatSection({ businessID }) {
  const { isCollapsed, complete, expand } = useCompleted('onboarding-web-chat-completed', false);

  return (
    <OnboardingSection className="web-chat" collapsed={isCollapsed} onClick={expand}>
      <h2>Add Web Chat to your site</h2>
      <div className="not-completed-section">
        <WebChatInstructions {...{ businessID, complete }}/>
      </div>
    </OnboardingSection>
  );
}

function WebChatInstructions({ businessID, complete }) {
  const title = 'Broadly Web Chat installation instructions';
  const text  = 'Use these instructions to add Broadly Web Chat to the web site.';
  const url   = `https://owner.broadly.com/business/${businessID}/webchat`;

  const shareIsSupported = Share.isSupported();
  const mailToLink       = getMailToLink({ title, text, url });
  const useMailToLink    = !shareIsSupported && mailToLink;

  async function shareInstructions() {
    await Share.share({ title, text, url });
  }

  return (
    <>
      <Link href={url} external>
        <div className="web-chat-example"/>
      </Link>
      <p>
          Add Web Chat to your website and convert inquiries into new business opportunities. We’ll qualify questions and capture contact information, then pass the ball to you as a “lead” so you can continue the conversation in the Broadly App.
      </p>
      <div className="actions">
        <Link className="button button-fill" href="https://broadlyhelp.force.com/s/wi" external>
          <span className="label">Ask Broadly</span>
          <ArrowRight/>
        </Link>
        <Link className="button view-instructions-button" href={url} external>
          <span className="label">View instructions</span>
          <FileIcon/>
        </Link>
        {shareIsSupported && (
          <button className="button share-instructions-button" onClick={shareInstructions}>
            <span className="label">Share instructions</span>
            <ShareIcon/>
          </button>
        )}
        {useMailToLink && (
          <Link href={mailToLink} external className="button email-instructions-button">
            <span className="label">Email instructions</span>
            <SendIcon/>
          </Link>
        )}
      </div>
      <div className="other-actions">
        <span className="link" onClick={complete}>
          I’ve already done this
        </span>
      </div>
    </>
  );
}

function getMailToLink({ title, text, url }) {
  const mailto  = 'mailto:';
  const subject = title;
  const body    = [ text, url ].filter(Boolean).join('\n\n');
  const query   = qs.stringify({ subject, body });
  const link    = [ mailto, query ].filter(Boolean).join('?');
  return link;
}
